/**
 * Highlight the matched substring of a search query within a label.
 *
 * The yellow treatment matches the Franchise Partner search dropdown - the
 * established pattern across the app. Shared so searchable selects
 * (`SearchSelect`, `FranchisePartnerSearchField`) render matches identically.
 *
 * Case-insensitive; splits on a capturing group so matched segments land on
 * the odd indices (no stateful `regex.test` lastIndex pitfall).
 */
import React from 'react'

const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export function highlightMatch(
  text: string,
  query: string | undefined,
): React.ReactNode {
  const q = (query ?? '').trim()
  if (!q) return text
  const parts = text.split(new RegExp(`(${escapeRegExp(q)})`, 'gi'))
  return parts.map((part, index) =>
    index % 2 === 1 ? (
      <mark
        key={index}
        style={{ backgroundColor: '#ffeb3b', fontWeight: 700, padding: 0, color: 'inherit' }}
      >
        {part}
      </mark>
    ) : (
      part
    ),
  )
}
